//
// Sliding Shop Links
//

module.exports = class SlidingShopLinksWidget {
  constructor($host, config) {
    this.config = config;

    this.dom = {
      main: $host,
      slides: $('.sliding-shop-link-slides', $host)
    };

    this.flickity = new Flickity(this.dom.slides[0], {
      pageDots: false,
      wrapAround: true,
      prevNextButtons: false
    });

    this.dom.main.on('mouseenter', () => this.flickity.next());
  }
};
